import React from "react";
import { FaRegSquareCaretUp } from "react-icons/fa6";
import { Link } from "react-router-dom";

// Reusable Search Input Component
const SearchInput = ({ value, onChange, placeholder, head, icon }) => {
    return (
        <div className="p-4 w-full justify-between flex items-center space-x-4">
            <h1 className="text-lg md:text-3xl font-bold">{head}</h1>
            {icon && (
                    <Link 
                        to='/'
                        className="text-green-500 hover:text-green-700 cursor-pointer text-4xl "
                    >
                        {icon}
                    </Link>
                )}
                <input
                    type="text"
                    placeholder={placeholder || "Search..."}
                    value={value}
                    onChange={onChange}
                    className="flex-1 p-2 border w-10 border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
            {/* <FaRegSquareCaretUp className="text-gray-500 hover:text-blue-500 cursor-pointer" /> */}
        </div>

    );
};

export default SearchInput;
